export default "fonts/toboto_medium.ttf";